(function() {
	var loadmore = false;

    // infinite scroll accomododation offers
	$(window).on('scroll', function() {

		// Half of the document reached?
		if ($(window).scrollTop() + $(window).height() >= getDocHeight() / 2) {
			var parent = $('.parent > div');
			var url = parent.find('.page-products').last().data('next-page-url');
			
			if (url && !loadmore) {
				loadmore = true;

				$.ajax({
					url: url,
					method: 'get',
					dataType: 'html',
					beforeSend: function() {
						// parent.data("loading", true);
						// parent.find("button[type=submit], button:not([type])")
						// 	.addClass("btn--loading")
						// 	.attr("disabled", true)
						// 	.prop("disabled", true);
					},
					success: function(response) {
						if (response) {
							parent.append(response);
						}
					},
					error: function(jqXhr) {
						var status = jqXhr.status;
						var response = jqXhr.responseText;
			
						if (status == 500) {
							alert("Грешка на сървъра");
						}
						else {
							alert("Грешка");
						}
					},
					complete: function() {
						loadmore = false;
						// setTimeout(function() {
			
						// 	$this.find("button[type=submit], button:not([type])")
						// 		.removeClass("btn--loading")
						// 		.removeProp("disabled")
						// 		.removeAttr("disabled");
						// 	$this.data("loading", false);
			
						// }, 500);
			
						// $(".filters-container .icon-close").trigger('click');
			
					}
				});
			}
		}
	});
})();

function getDocHeight() {
	var D = document; 
	return Math.max( 
		D.body.scrollHeight, 
		D.documentElement.scrollHeight, 
		D.body.offsetHeight, 
		D.documentElement.offsetHeight, 
		D.body.clientHeight, 
		D.documentElement.clientHeight 
	);
}